import {
  HISTORY_GET_SPORT_BETS_HISTORY,
  HISTORY_GET_SPORT_BETS_HISTORY_SUCCESS,
} from "@shared/constants";

import { createReducer } from "./utils";

const initialState = {
  sportBetsHistory: {
    created: {
      isPending: false,
      isFetching: false,
      isFetchingNextPage: false,
      isInitialFetch: true,
      hasNextPage: true,
      items: [],
    },
    "non-created": {
      isPending: false,
      isFetching: false,
      isFetchingNextPage: false,
      isInitialFetch: true,
      hasNextPage: true,
      items: [],
    },
  },
};

export default createReducer(initialState, {
  [HISTORY_GET_SPORT_BETS_HISTORY](state, { payload }) {
    return {
      ...state,
      sportBetsHistory: {
        ...state.sportBetsHistory,
        [payload.status]: {
          ...state.sportBetsHistory[payload.status],
          isPending: state.sportBetsHistory[payload.status].isInitialFetch,
          isFetchingNextPage: payload.offset > 0,
          isFetching: true,
        },
      },
    };
  },

  [HISTORY_GET_SPORT_BETS_HISTORY_SUCCESS](state, { payload }) {
    console.debug("HISTORY_GET_SPORT_BETS_HISTORY_SUCCESS", payload);

    return {
      ...state,
      sportBetsHistory: {
        ...state.sportBetsHistory,
        [payload.status]: {
          isPending: false,
          isFetching: false,
          isFetchingNextPage: false,
          isInitialFetch: false,
          hasNextPage: payload.response.list.length > 0,
          items: state.sportBetsHistory[payload.status].isFetchingNextPage
            ? [
                ...state.sportBetsHistory[payload.status].items,
                ...payload.response.list,
              ]
            : payload.response.list,
        },
      },
    };
  },
});
